import React from 'react';
import * as ContextTitle from '../../../constants/K007/ContextTitle';

/**
 * ContextMenuPachi
 */
class ContextMenuPachi extends React.Component {

  render() {
    const contextTitleArea = [];
    for (let i = 0; i < ContextTitle.CONTEXT_TITLE.length; i++) {
      if (ContextTitle.CONTEXT_TITLE[i].name != '設定別') {
        const contextid = 'context' + i;
        contextTitleArea.push(
          <li className="section_context" id={contextid} key={i}>
            <a className="context_menu_a" href="" >{ContextTitle.CONTEXT_TITLE[i].name}</a>
          </li>
        );
      }
    }

    return (
      <div id="context_menu">
        <ul>
          <li id="context_item_name" />
          {contextTitleArea}
        </ul>
      </div>
    );
  }
}

export default ContextMenuPachi;
